import React from 'react';
import { useData } from '../context/DataContext';
import "./AuthComponent.css";

export const AuthComponent = () => {
    const { user } = useData();

    const handleLogout = () => {
        // Clear the stored nickname and reload to show the login prompt
        localStorage.removeItem('deskshare_nickname');
        window.location.reload();
    };

    if (!user) {
        return null; // Should not be visible if there's no user
    }

    return (
        <div className="auth-container">
            <span className="user-name">Welcome, {user.name}</span>
            <button onClick={handleLogout} className="auth-button">Sign Out</button>
        </div>
    );
};